<template>
    <BModal ref="modal" :title="$t('componentEditHub.replaceOrDeleteTitle', { type: componentType })" centered no-close-on-backdrop header-class="modal-title text-danger" modal-class="no-border-modal">
        <div class="px-2">
            <!-- Choix de l'opération -->
            <label class="form-label fw-bold">{{ $t('componentEditHub.operation') }}</label>
            <div class="form-check">
                <input class="form-check-input" type="radio" id="operation-replace" value="replace" v-model="operation" disabled>
                <label class="form-check-label" for="operation-replace">{{ $t('componentEditHub.replace') }}</label>
                <div class="form-text">{{ $t('componentEditHub.replaceHint', { type: componentType }) }}</div>
            </div>
            <div class="form-check">
                <input class="form-check-input" type="radio" id="operation-delete" value="delete" v-model="operation">
                <label class="form-check-label" for="operation-delete">{{ $t('common.delete') }}</label>
            </div>

            <!-- Motif -->
            <label class="form-label fw-bold mt-3">{{ $t('componentEditHub.reasonLabel') }}</label>
            <div class="form-check">
                <input class="form-check-input" type="radio" id="reason-defective" value="defective" v-model="reason">
                <label class="form-check-label" for="reason-defective">{{ $t('componentEditHub.reasonDefective') }}</label>
            </div>
            <div class="form-check">
                <input class="form-check-input" type="radio" id="reason-site-change" value="site_change" v-model="reason">
                <label class="form-check-label" for="reason-site-change">{{ $t('componentEditHub.reasonSiteChange') }}</label>
            </div>
            <div class="form-check">
                <input class="form-check-input" type="radio" id="reason-other" value="other" v-model="reason">
                <label class="form-check-label" for="reason-other">{{ $t('componentEditHub.reasonOther') }}</label>
            </div>
            <input v-if="reason === 'other'" type="text" class="form-control mt-2" maxlength="255"
                :placeholder="$t('componentEditHub.reasonOtherPlaceholder')" v-model="otherReason" required>
        </div>
        <template #footer="{ cancel }">
            <div class="d-flex justify-content-between align-items-center w-100">
                <button type="button" class="btn btn-secondary" @click="cancel">{{ $t('common.cancel') }}</button>
                <button type="button" class="btn btn-danger ms-2" :disabled="!canConfirm" @click="confirm">{{ $t('common.delete') }}</button>
            </div>
        </template>
    </BModal>
</template>

<script>
import { BModal } from 'bootstrap-vue-next';
import { computed, ref } from 'vue';

export default {
    name: 'ReplaceOrDeleteHubModal',
    components: {
        BModal
    },
    props: {
        action: {
            type: Function,
            required: true
        },
        componentType: {
            type: String,
            default: 'HUB'
        }
    },
    setup(props) {
        const modal = ref(null);
        const operation = ref('delete');
        const reason = ref(null);
        const otherReason = ref('');

        const show = () => {
            operation.value = 'delete';
            reason.value = null;
            otherReason.value = '';
            modal.value.show();
        };

        const hide = () => {
            modal.value.hide();
        };

        const canConfirm = computed(() =>
            operation.value === 'delete' &&
            reason.value !== null &&
            (reason.value !== 'other' || otherReason.value.trim().length > 0)
        );

        const confirm = () => {
            props.action({
                reason: reason.value === 'other' ? otherReason.value.trim() : reason.value,
            });
            hide();
        };

        return {
            modal,
            operation,
            reason,
            otherReason,
            canConfirm,
            confirm,
            show,
            hide,
        };
    }
}
</script>
